<template>
  <div>
    <div class="kyc-title-header-wrap">
      <img
        src="/static/svg/icon-kyc-kulap-plus.svg"
        class="kyc-icon"
      >
    </div>
    <div class="kyc-title">
      {{ $t('kyc.verify_kulap_plus_title') }}
    </div>
    <div class="kyc-detail-wrap">
      <div class="kyc-detail">
        {{ $t('kyc.verify_kulap_plus_detail') }}
        <a
          :href="kulapPlusNewKycLink"
          target="_blank"
          class="kyc-status-link"
        >
          {{ $t('kyc.verify_kulap_plus_link_text') }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { getKulapPlusURL } from '@/environments'

export default {
  name: 'KulapPlusKycCard',
  computed: {
    kulapPlusNewKycLink () {
      return `${getKulapPlusURL()}/kyc`
    }
  }
}
</script>
<style lang="scss" scoped>
.kyc-title-header-wrap {
  display: flex;
  justify-content: center;
}
.kyc-title {
  // margin: 35px 0;
  margin: 20px 0;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: #000000;
}
.kyc-detail-wrap {
  padding: 0 20px;
}
.kyc-detail {
  font-size: 17px;
  text-align: left;
}

.kyc-status-link {
  font-size: 17px;
  font-weight: bold;
  line-height: 50px;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kyc-icon {
  width: 90px;
  height: 90px;
}
</style>



// WEBPACK FOOTER //
// src/pages/KYC/components/kulapPlusKycCard.vue